module.exports = __webpack_public_path__ + "2ede8280131841764f459d4cbe28eaee.pdf";